import { Box } from "@mui/material";
import type { ReactNode } from "react";
import { type IResponsiveScrollOptions, useResponsiveScroll } from "./logics";

export interface IResponsiveScrollProps {
  scroller: HTMLElement | null;
  mainContainer: HTMLElement | null;
  subContainer: HTMLElement | null;
  staticContainer: HTMLElement | null;
  options?: IResponsiveScrollOptions;
  children: ReactNode;
}

export const ResponsiveScroll = ({
  scroller,
  mainContainer,
  subContainer,
  staticContainer,
  options,
  children,
}: IResponsiveScrollProps) => {
  const { animated, mainContainerHeight, scaleY, collapseHeight } = useResponsiveScroll(
    scroller,
    mainContainer,
    subContainer,
    staticContainer,
    options
  );
  const hasCollapseThreshold = options?.collapseThreshold !== undefined;

  return (
    <Box
      sx={{
        position: "sticky",
        top: 0,
        zIndex: 1,
        minHeight: hasCollapseThreshold ? collapseHeight : mainContainerHeight,
        transformOrigin: "top",
        transform: `scaleY(${scaleY})`,
      }}
    >
      <Box
        sx={{
          position: "relative",
          minHeight: collapseHeight - 0.5,
          ...(animated && { transition: "min-height 0.25s" }),
          overflow: "hidden",
          transformOrigin: "top",
          transform: `scaleY(${1 / scaleY})`,
        }}
      >
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            width: "100%",
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};
